import {  FC,useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import {  useLocation, useHistory } from "react-router-dom";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import css from "../../../smallnation/assets/custom.css";
import UsNumberValidate from "../../modules/utility/usNumberValidate"
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
//import publichttp from "./http-public";
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';

const Option = (props) => {
  return (
      <div>
          {
              //console.log("results=="+JSON.stringify(props))
          }
          <components.Option {...props}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
              />{" "}
              <label>{props.label}</label>
          </components.Option>
      </div>
  );
};


const PromoteCompany: FC = () => {
      const intl = useIntl();
      const red="red";
      const [companyList, setCompanyList] = useState([]);
      const [query, setQuery] = useState("");
      const [mulcompanyids, setMulCompanyIds] = useState([]);
      
      const [optionCatSelected_d, setoptionCatSelectedd] = useState([]);
      const [sourceCompanyId, setSourceCompanyId] =  useState<any>([]);
      const [destCompanyId, setDestCompanyId] = useState<any>([]);
      let history = useHistory();
      const [selectedCompany, setSelectedCompany] = useState('');
      const [companyRequestArray_d, setCompanyRequestArrayd] = useState([]);
      const [logourlDisplay, setLogoUrlDisplay] = useState('');
      const [employeeCount, setemployeeCount] = useState('');
      const [companyName, setcompanyName] = useState('');
      const [companyAddress, setcompanyAddress] = useState('');
      const [adminName, setadminname] = useState('');
      const [adminEmail, setadminemail] = useState('');
      const [totalActiveJobs, setTotalItems] = useState(0);
      const [totalPendingJobs, setTotalPendingItems] = useState(0);
      const [userList, setUsersList] = useState([]);
      const [destuserList, setDestUsersList] = useState([]);
      const [featuredvideos, setFeaturedVideos] = useState([]);
      
      const {
         register,
         formState: { errors },
         handleSubmit
       } = useForm({
         criteriaMode: "all",mode: "onBlur" 
       }); 

      function validateCheck() {
        //alert("test");
      }

      const animatedComponents = makeAnimated();

      const submitValue=()=>
      {
        var chkSourceCompanyId = sourceCompanyId.companyId;
        var chkDestCompanyId = destCompanyId.companyId;
       // alert(chkSourceCompanyId+"  "+chkDestCompanyId);
        var validateEditorTxt = 1;
        if(chkSourceCompanyId == "" || typeof(chkSourceCompanyId) == "undefined"){
          $("#sourcecompanyValidMsg").show();
          $(window).scrollTop($('#sourcecompanyValidMsg').position().top);
          validateEditorTxt = 0;
        } else {
          $("#sourcecompanyValidMsg").hide();
        }

        if(chkDestCompanyId == "" || typeof(chkDestCompanyId) == "undefined"){
          $("#destinationcompanyValidMsg").show();
          $(window).scrollTop($('#destinationcompanyValidMsg').position().top);
          validateEditorTxt = 0;
        }else {
          $("#destinationcompanyValidMsg").hide();
        }

        if(chkSourceCompanyId == chkDestCompanyId)
        {
          $("#mergecompanyfailMessageDuplicate").show();
          validateEditorTxt = 0;
        }else{
          $("#mergecompanyfailMessageDuplicate").hide();
        }

        if (validateEditorTxt == 0) {
          return false;
        }
    
        const requestObject =
        {
          "sourceCompanyId":chkSourceCompanyId,
          "destinationCompanyId":chkDestCompanyId
        }

        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };
        services.adminMergeCompanies(requestOptions).then((res) => 
        {    
          if (res.code == '200') {
            $("#mergecompanysuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#mergecompanysuccessMessage").slideUp(2500);
            });
            setTimeout(() => {
              history.push('/companyDetails?companyId=' + chkDestCompanyId+'&tab='+2); 
              
            }, 1000);
          }
        });
      }

      const loadOptionsSource =  (query) => {
       // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());

       var result_set = '';
       var statuschk = 'published';
       var sortBy = '';
       var sortDir = '';
       var pageSize = '60';
       var pageNumber = '1';
       var siteId = '2'

       var queryval = query;
    var encoded_queryval = encodeURIComponent(queryval)

       var endpoint= process.env.REACT_APP_AWS_API+`searchCompanyVideos?name=`;

        fetch(endpoint).then(response => {
          response.json().then(data => {
              console.log(data);
              const results = data;
             // const results = data.content;

              var statuschkval = 'pending';
     
              var queryval = query;
              var encoded_queryval = encodeURIComponent(queryval)
     
              var endpoint= process.env.REACT_APP_AWS_API+`searchCompanyVideos?name=`+encoded_queryval;
     
              fetch(endpoint).then(response => {
                response.json().then(data => {

                    //const results2 = data.content;
                    const results2 = data;
                    console.log('************')
                    
                    //const resultsetgroup = results.concat(results2);
                    const resultsetgroup = results2;
                    console.log(resultsetgroup);
                    setCompanyList(resultsetgroup);
                    var dummArray = [];
                    for (var i = 0; i < resultsetgroup.length; i++) {
                        dummArray.push({ "label": resultsetgroup[i].name, "value": resultsetgroup[i].companyId })
                    }
                    setMulCompanyIds(dummArray);
                   // callback(resultsetgroup);            
                });
          });
        });
      });

      };

      

      function removeUnmatchedObjects(array1, array2, key1, key2) {
        const matchedValues = array2.map(obj => obj[key2]);
        return array1.filter(obj => matchedValues.includes(obj[key1]));
    }

      const handleChangeForCompany = (selected) => {
        console.log(selected);
        if(selected.length<4){
          $('#companymaxselection').hide();
          var dummArray = [];
          var dummArray_label = '';
          var dummy_video = [];
          for (var i = 0; i < selected.length; i++) {
              //alert(selected[i].label.toString());
              dummArray.push(selected[i].value.toString());
              if(i==0){
                dummArray_label = selected[i].label.toString();
              } else{
                dummArray_label = dummArray_label+', '+selected[i].label.toString();
              }
              //setFeaturedVideos(prevItems => prevItems.filter(item => item.companyId === selected[i].value));
          }
          setCompanyRequestArrayd(dummArray);
          setoptionCatSelectedd(selected);
          var filteredvideosobj = removeUnmatchedObjects(featuredvideos, selected, 'companyId', 'value');
          console.log(filteredvideosobj);
          setFeaturedVideos(filteredvideosobj);
          setSelectedCompany(dummArray_label);
        } else {
          $('#companymaxselection').show();
          return ;
        }
        
      }

      
      useEffect(() => {
        $(".load-wrap").hide();
        validateCheck();
        //$('#soucecompany').hide();
        $('#mergecompanysuccessMessage').hide();
        $('#mergecompanyfailMessage').hide();
        $('#sourcecompanyValidMsg').hide();
        $('#companymaxselection').hide();
        loadOptionsSource('');
        getAdminDefaultVideosList();
      }, []);

      const getFeaturedVideos = () => {
        console.log(companyRequestArray_d);
        const requestObject = {
          "companyIds": companyRequestArray_d
        }
        console.log(requestObject);
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn 
            //'Authorization': accessTokenIn 
          },
          body: JSON.stringify(requestObject)
        };
    
        services.getAdminUpdateFeaturedVideos(requestOptions).then((res) => {
          if (res) {
            try {
              
              getAdminDefaultVideosList();
            } catch (ex) {
              console.log("ex:" + ex);
            }
          }
        });
      } 

      const getAdminDefaultVideosList = () => {
        $(".load-wrap").show();
        services.getAdminCompanyFeaturedVideos().then((response) => {
          if(response){
            console.log(response.data);
            var dummArray_default = [];
            var dummArray_id = [];
            for (var i = 0; i < response.data.length; i++) {
              dummArray_default.push({ "label": response.data[i].companyName, "value": response.data[i].companyId })
              dummArray_id.push(response.data[i].companyId);
            }
            setCompanyRequestArrayd(dummArray_id);
            setoptionCatSelectedd(dummArray_default);
            setFeaturedVideos(response.data);
            $(".load-wrap").hide();
          }
        });
      }

      const remove_companyfeatured = (companyid) => {
        $('#companymaxselection').hide();
          var newdummArray = [];
          var newdummyids = [];
          var newdummArrayvideo = [];
          for (var i = 0; i < optionCatSelected_d.length; i++) {
            console.log(optionCatSelected_d[i].value +'-'+ companyid)
            if(optionCatSelected_d[i].value != companyid){
              newdummyids.push(optionCatSelected_d[i].value);
              newdummArray.push(optionCatSelected_d[i]);
            } else{
              console.log('matched');
            }
          }
          console.log(newdummArray);
          setTimeout(() => {
            setoptionCatSelectedd(newdummArray);
            setCompanyRequestArrayd(newdummyids);
            console.log(optionCatSelected_d);

            for (var i = 0; i < featuredvideos.length; i++) {
              console.log(featuredvideos[i].companyId +'-'+ companyid)
              if(featuredvideos[i].companyId != companyid){
                newdummArrayvideo.push(featuredvideos[i]);
              } else{
                console.log('matched');
              }
            }
            console.log(newdummArrayvideo);
            setFeaturedVideos(newdummArrayvideo);
            console.log(featuredvideos);
          }, 1000) 
      }
      return (
        <>
        <PageTitle breadcrumbs={[]}>Manage Homepage Videos</PageTitle>
        <form onSubmit={handleSubmit(submitValue)}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 px-0">
                <div className="mb-0">
                  <div className="d-flex flex-column ">
                    <label htmlFor="exampleFormControlInput1" className="required form-label">Company Name</label>
                    <small className="mb-3">Select max 3 Companies.</small>
                    
                  </div>
                  <div id="companymaxselection" style={{color:red}} className="error">You have already selected max number of comapanies.</div>

                    <ReactSelect
                      //className="form-select"
                      options={mulcompanyids}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForCompany}
                      
                     // allowSelectAll={false}
                      value={optionCatSelected_d}
                      //isDisabled={optionCatSelected_d.length >= 3}
                      defaultValue={['1']}
                  />
                  
                  <div id="sourcecompanyValidMsg" style={{color:red}} className="error">Company Name is required.</div>
                </div>
              </div>
              <div className="d-flex gap-2 align-item-center homevidcompany_suggestion"><img width="18px"  src="/media/logos/info-circle.svg" />The search field will only show companies with available videos.</div>
              <div className="container px-0" id="soucecompany">
                <div className="row">
                
                  {
                    featuredvideos.map((data, index) => (

                    <div className="col-lg-4">
                    <div className="mb-10" style={{position:"relative"}}>
                      <div className="d-flex flex-column mb-1 ">
                      
                        <ReactPlayer url={data.url} controls={true} width="100%" height="175px" config = {
                        {
                          facebook: {
                            attributes: {
                              'data-width': 'auto',
                              'data-height': 'auto'
                            }
                          }
                        }
                      } />
                      </div>
                      <a className="rmbutton my-2 ms-auto" onClick={() => remove_companyfeatured(data.companyId)}><img width="18px"  src="/media/logos/cc2.svg"/>Remove</a>

                    </div>
                  </div>

                    ))}
                    
                </div>

              </div>


              <div className="col-lg-12">
                <div>
                  <div className="d-flex flex-column ">
                    <div className="row">
                      <div className="divider"></div>
                 
                      <button type="button" onClick={getFeaturedVideos} className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Update </button>
            
                    </div>
                  </div>

                 <div id="mergecompanysuccessMessage" className="alert alert-success" role="alert">
                 Homepage Videos managed successfully.
                  </div>
                 <div id="mergecompanyfailMessage" className="alert alert-danger" role="alert">Please try again</div>
                                           
              </div>
                 </div>

               </div>
             </div>
             <section className="load-wrap">
          <div className="loadingIcon">
            <img src="/media/icons/duotune/general/loading.gif" className="m-auto"></img>
            <span>Loading... <br /> please be patient..</span>
             </div>
        </section>
</form>
        </>
      )
    }
export {PromoteCompany}